import React from "react";

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {
  PlayersStatisticsTableRowValueViewModel
} from "../../../../domain/yard/lineups/players-statistics/tables/rows/values/players-statistics.table.row.value.view-model";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";
import {Image} from "../../../../core/components/image/image";

class BoxScoresWidgetTableStatsCellsValueProps extends BaseProps {
  value: PlayersStatisticsTableRowValueViewModel;
  emptyCell: String;
}

export const BoxScoresWidgetTableStatsCellsValue = (({value, emptyCell}: BoxScoresWidgetTableStatsCellsValueProps) => {
  if (!value?.value) {
    return emptyCell;
  }

  const iconProps = {
    className: classnames(styles.stat_icon),
    src: value.logoRequestParam
  }

  return value.shouldRenderIcon ? <Image {...iconProps}/> : value?.value
});
